import react, { useEffect, useState, useRef } from 'react'
import axios from 'axios';
import _ from 'lodash';
import { useHistory } from "react-router-dom";
import { Animate } from 'react-simple-animate';
import GreenCircleV2 from './../svgs/greenCircle_v2'
const baseurl = process.env.REACT_APP_FRONT_LINK;

// import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
const questionobj = [
    {
        image: ""
    }
]

function ListenAndChooseTheWord(props) {
    const [data, setData] = useState([]);
    const [current, setCurrent] = useState(0);
    const [question, setQuestion] = useState({});
    const [userSelect, setUserSelect] = useState("");
    const [showCorrect, setShowCorrect] = useState(false);
    const [audio, setAudio] = useState("");
    const [answer, setAnswer] = useState(0);
    const history = useHistory();

    const instr = useRef();

    useEffect(() => {
        document.getElementById("intr").play();

    }, [])
    useEffect(() => {
        setCurrent(0);
    }, [props.questions])

    const checkQuestion = (e) => {

        let counterNext = current;
        // let currentData = data;

        counterNext++;


        if (question.userAnswer === question.correct) {
            // props.playAudio(true);
            // setShowCorrect(true);
            document.getElementById("correct-au").play();
            setQuestion({
                ...question,
                correctAnswer: true
            })
        } else {

            //  props.playAudio(false);
            // setShowCorrect(true);
            document.getElementById("wrong-au").play();
            setQuestion({
                ...question,
                correctAnswer: false
            })
        }

        setTimeout(() => {

            if (counterNext < data.length) {
                let selected = data[counterNext];
                selected.answers = _.shuffle(selected.answers);
                let find = selected.answers.findIndex((item) => item.correct === true);

                setQuestion(selected);
                setAudio(selected.audio);
                setShowCorrect(false);
                setUserSelect("");
                setCurrent(counterNext);
                document.getElementById("intr").play();

                setTimeout(() => {
                    // document.getElementById("intr2").play();


                }, 300)

            } else {
                // history.push(baseurl + "goodjob")

                let answerFormat = {
                    pass: true,
                    progress: 0,
                    questionTitle: "Look and notice.",
                    userAnswers: [],
                    type: "look-notice"
                }

                let userType = localStorage.getItem("userType");

                if (userType === "teacher") {
                    // teacher: do not advance automatically
                } else {

                    props.nextExercise(answerFormat);
                }

                window.location.hash = "#20";
            }
        }, 3000);


        /*setTimeout(() => {
            history.push(baseurl + "drag")
        }, 3000);*/


        // setTimeout(() => {
        //     setShowCorrect(false);

        //     if(data[counterNext] !== undefined) {
        //         currentData[counterNext].complete = true;
        //         data[counterNext].answers = _.shuffle(data[counterNext].answers);



        //         setData(currentData);
        //         setCurrent(counterNext);
        //         setQuestion(data[counterNext])
        //         setUserSelect("");
        //     } else {
        //         props.setShowGoodJob(true);
        //     }
        //     setTimeout(() => {
        //         if(document.getElementById("question-audio") !== null) {
        //             document.getElementById("question-audio").play();
        //         }
        //     }, 500);
        // }, 3000);

    }

    const playAudio = (e) => {
        if (document.getElementById("question-audio") !== null) {
            document.getElementById("question-audio").play();
        }
    }

    const checkUserSelect = (userSelect, indx) => {
        if (userSelect === indx) {
            return ("selected multiple-question-item");
        } else {
            return ("multiple-question-item");
        }
    }

    const checkCorrect = (userSelect, indx, correct) => {

        if (correct === true) {
            return ("multiple-question-item selected correct")
        } else {
            if (userSelect === indx) {
                return ("selected wronganswer multiple-question-item");
            } else {
                return ("multiple-question-item");
            }
        }

    }

    const playIntr = (e) => {
        document.getElementById("intr").play();
    }


    return (<div>




        <div className="question-title-container" style={{ width: "50vw", margin: "auto" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <img src={baseurl + "assets/game5/listen.svg"} />
                <h1 className="question-title">{props.quizsection.subtitle}</h1>

            </div>
            <div id="audio-bt" onClick={playIntr}><img src={baseurl + "assets/audio/listen.png"} /></div>
        </div>

        <div className="question-container look-notice">
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "column"
                }}
            >
                <div style={{
                    textAlign: "left",
                    width: "50vw"
                }}>

                    <GreenCircleV2 width={170} height={"auto"} style={{ marginTop: -20 }} />

                </div>
                <div><img src={baseurl + "assets/vertical/looknotice.png"} /></div>

            </div>



            <div className="button-check">
                <button className="check-answer-bt" onClick={checkQuestion} variant="contained" color="primary">Next</button>

            </div>


            <audio src={`${baseurl}assets/levels/level1/unit1/assets/audios/look_and_notice.mp3`} className="hidden-audio" id="intr" />

            <audio src={`${baseurl}assets/audio/correct.mp3`} className="hidden-audio" id="correct-au" />
            <audio src={`${baseurl}assets/audio/wrong.mp3`} className="hidden-audio" id="wrong-au" />

            {/* <audio src={`${baseurl}assets/tracks/t08/track8.mp3`} className="hidden-audio" id="intr2" /> */}

        </div>


    </div>)
}

export default ListenAndChooseTheWord;